import { useEffect } from 'react';

interface Props {
    message: string | null;
    onClose: () => void;
    duration?: number;
}

export default function Toast({ message, onClose, duration = 3000 }: Props) {
    useEffect(() => {
        if (!message) return;

        const timer = setTimeout(() => {
            onClose();
        }, duration);

        return () => clearTimeout(timer);
    }, [message, duration, onClose]);

    if (!message) return null;

    return (
        <div className="store-toast" role="status">
            <span className="store-toast__icon">✓</span>
            <span className="store-toast__message">{message}</span>
        </div>
    );
}
